import { FaCheck } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./VerifiedBadge.css";

export default function VerifiedBadge({ verified, className = "" }) {
  const { t } = useTranslation();

  if (!verified) return null;

  return (
    <span
      className={`verified-badge ${className}`.trim()}
      title={t("verifiedBadge.label")}
      aria-label={t("verifiedBadge.label")}
    >
      <FaCheck aria-hidden="true" />
    </span>
  );
}
